import { Component, OnInit, ElementRef, AfterViewInit } from '@angular/core';

import { Observable, forkJoin } from 'rxjs';

import { PixService } from './../../../../shared/services/pix/pix.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';
import { ICobrancaPixReturnViewModel } from '../../../../shared/interfaces/cobranca-pix.interface';

import { environment } from './../../../../../environments/environment';

import * as moment from 'moment';
import * as Taggle from 'taggle';
import * as XLSX from 'xlsx';
import { LoginService } from '../../../../shared/services/auth/login/login.service';

declare var $: any;

@Component({
  selector: 'app-cobrancas-pix',
  templateUrl: './cobrancas-pix.component.html',
  styleUrls: ['./cobrancas-pix.component.scss']
})
export class CobrancasPixComponent implements OnInit, AfterViewInit {
  public isPagueLaAdmin = false;
  public table: any = null;
  public maxTags = 4;
  public tagglejs: any = null;
  public cobrancasPix: ICobrancaPixReturnViewModel[] = [];
  public cobrancasPixBkp: ICobrancaPixReturnViewModel[] = [];

  public error = false;
  public loaded = false;
  public success = false;

  public inputSearch = '';
  public boxHidden = true;

  public finalDateFilter: Date;
  public initialDateFilter: Date;
  public isGettingCobrancasPix = false;

  public status: any = [
    { name: 'Pago', className: 'status-pago', actived: false },
    { name: 'Pendente', className: 'status-pendente', actived: false }
  ];

  constructor(
    private elRef: ElementRef,
    private localStorage: LocalStorageService,
    private pixService: PixService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.clickListener();
    this.clickOutListener();

    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);
    
    this.initialDateFilter = lastMonth;
    this.finalDateFilter = today;

    moment.locale('pt-br');

    this.isPagueLaAdmin = this.loginService.isAdmin(); 
  }

  ngAfterViewInit() {
    const self = this;
    this.tagglejs = new Taggle('input-tag', {
      onTagAdd: function() {
        self.filter();
      },
      onTagRemove: function(e, tag) {
        self.markTagAsInactive(tag);
        self.filter();
      },
      placeholder: '',
      maxTags: this.maxTags,
      preserveCase: true,
    });
    this.getCobrancasPix(); 
  }

  clickListener() {
    const caixaPesquisa = this.elRef.nativeElement.querySelector('.caixa-pesquisa');
    if (caixaPesquisa) {
      const self = this;
      this.elRef.nativeElement.querySelector('.caixa-pesquisa').addEventListener('click', function(e) {
        self.elRef.nativeElement.querySelector('.input-searchbox').focus();
      });
    }
  }

  changeTag(e, value) {
    if (this.tagglejs.tag.values.length === this.maxTags) {
      return;
    }

    if (e.target.checked) {
      this.addTag(value);
      this.markTagAsActive(value);

      e.target.checked = false;
    }
  }

  addTag(value) {
    this.tagglejs.add(value);
  }

  markTagAsActive(value) {
    this.status.forEach((s) => {
      if (s.name === value) {
        s.actived = true;
      }
    });
  }

  markTagAsInactive(value) {
    this.status.forEach((s) => {
      if (s.name === value) {
        s.actived = false;
      }
    });
  }

  getCobrancasPix() {
    this.cobrancasPix = [];

    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    let initialDate: any = moment(this.initialDateFilter).format('DD/MM/YYYY').replace(/\//g, '-');

    initialDate = initialDate.split('-');
    initialDate = new Date(initialDate[2], initialDate[1] - 1, initialDate[0]);

    initialDate = moment(initialDate).format('YYYY-MM-DD');

    let finalDate: any = moment(this.finalDateFilter).format('DD/MM/YYYY').replace(/\//g, '-');

    finalDate = finalDate.split('-');
    finalDate = new Date(finalDate[2], finalDate[1] - 1, finalDate[0]);

    finalDate = moment(finalDate).format('YYYY-MM-DD');

    if (this.isGettingCobrancasPix) {
      return;
    }

    this.isGettingCobrancasPix = true;

    this.pixService.obterTransacoesPorPeriodo(user.PersonId, initialDate, finalDate).subscribe((data: any) => {
      this.isGettingCobrancasPix = false;
      
      if (data.Cobrancas) {
        data.Cobrancas.sort(function(a, b) {
          if (a.CobrancaPixId < b.CobrancaPixId) { return -1; }
          if (a.CobrancaPixId > b.CobrancaPixId) { return 1; }
          return 0;
        });

        data.Cobrancas.reverse();
        data.Cobrancas.forEach((row) => {
          row.ValorNumero = row.Valor;
          row.Valor = row.ValorNumero.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
        });

        this.cobrancasPix = data.Cobrancas;
        this.cobrancasPixBkp = this.cobrancasPix;
      }

      queueMicrotask(() => {
        this.filter();
      });
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  hasStatusInCobrancasPix(status) {
    let hasStatus = false;

    this.cobrancasPixBkp.forEach((cobrancaPix) => {
      if (status === 'Pago' && cobrancaPix.DataPagamento) {
        hasStatus = true;
      } else if (status === 'Pendente' && !cobrancaPix.DataPagamento) {
        hasStatus = true;
      }
    });

    return hasStatus;
  }

  toggleBox() {
    this.boxHidden = !this.boxHidden;
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;

    this.table = $('#master-detail-table').DataTable({
      order: [[2, 'desc']],
      scrollX: true,
      destroy: true,
      paging: true,
      pagingType: 'numbers',
      lengthChange: false,
      searching: false,
      processing: false,
      info: true,
      data: self.cobrancasPix,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function() {
        self.loaded = true;

        if (self.cobrancasPix && self.cobrancasPix.length === 0) {
          $('#master-detail-table_info').html('0 - 0 de 0');
        }
      },
      columns: [
        {
          title: 'Cliente',
          data: null,
          width: '200px',
          render: function(data, type, row) {
            let clienteInfo = '';
            if (row.Nome) {
              clienteInfo += row.Nome;
            }
            if (row.CpfCnpj) {
              const tipoDoc = self.getDocumentType(row.CpfCnpj);
              const docFormatado = self.formatDocument(row.CpfCnpj);
              clienteInfo += '<br><small><strong>' + tipoDoc + ':</strong> ' + docFormatado + '</small>';
            }
            return clienteInfo;
          }
        },
        {
          title: 'Pagador',
          data: null,
          width: '200px',
          render: function(data, type, row) {
            let pagadorInfo = '';
            if (row.NomePagador) {
              pagadorInfo += row.NomePagador;
            }
            if (row.CpfCnpjPagador) {
              const tipoDoc = self.getDocumentType(row.CpfCnpjPagador);
              const docFormatado = self.formatDocument(row.CpfCnpjPagador);
              pagadorInfo += '<br><small><strong>' + tipoDoc + ':</strong> ' + docFormatado + '</small>';
            }
            return pagadorInfo;
          }
        },
        {
          title: 'Data/Hora',
          data: null,
          render: function(data, type, row) {
            if (row.DataPagamento) {
              return moment(row.DataPagamento).format('DD/MM/YYYY HH:mm');
            }
            return 'Pendente';
          }
        },
        { title: 'Venda', data: 'Descricao' },
        { title: 'Chave', data: 'ChavePix' },
        { title: 'Valor', data: 'Valor' }
      ]
    });

    this.rowClickListener();

    $('#master-detail-table').on('page.dt', function() {
      self.rowClickListener();
    });
  }

  setFilterDate(e) {
    this.initialDateFilter = new Date(e.firstSelection.year, e.firstSelection.month - 1, e.firstSelection.day);
    this.finalDateFilter = new Date(e.lastSelection.year, e.lastSelection.month - 1, e.lastSelection.day);

    this.getCobrancasPix();
  }

  filter() {
    this.filterByNameAndDescription(false);
    this.filterByStatus(true);

    this.cobrancasPix.sort(function(a, b) {
      const dateA = a.DataPagamento ? moment(a.DataPagamento) : moment(0);
      const dateB = b.DataPagamento ? moment(b.DataPagamento) : moment(0);
      
      if (!dateA.isAfter(dateB)) { return 1; }
      if (dateA.isAfter(dateB)) { return -1; }
      return 0;
    });

    if (this.table) {
      this.table.destroy();
      this.showData();
    } else {
      this.showData();
    }
  }

  filterByNameAndDescription(init) {
    this.cobrancasPix = init ? this.cobrancasPix : this.cobrancasPixBkp;
    let cobrancasAux = [];

    if (this.inputSearch.length > 0) {
      this.cobrancasPix.forEach((cobrancaPix) => {
        if (cobrancaPix.Nome && cobrancaPix.Nome.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          cobrancasAux.push(cobrancaPix);
        }

        if (cobrancaPix.Descricao && cobrancaPix.Descricao.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          if (!cobrancasAux.includes(cobrancaPix)) {
            cobrancasAux.push(cobrancaPix);
          }
        }

        if (cobrancaPix.ChavePix && cobrancaPix.ChavePix.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          if (!cobrancasAux.includes(cobrancaPix)) {
            cobrancasAux.push(cobrancaPix);
          }
        }

        if (cobrancaPix.CpfCnpj && cobrancaPix.CpfCnpj.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          if (!cobrancasAux.includes(cobrancaPix)) {
            cobrancasAux.push(cobrancaPix);
          }
        }

        if (cobrancaPix.NomePagador && cobrancaPix.NomePagador.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          if (!cobrancasAux.includes(cobrancaPix)) {
            cobrancasAux.push(cobrancaPix);
          }
        }

        if (cobrancaPix.CpfCnpjPagador && cobrancaPix.CpfCnpjPagador.toLowerCase().includes(this.inputSearch.toLowerCase())) {
          if (!cobrancasAux.includes(cobrancaPix)) {
            cobrancasAux.push(cobrancaPix);
          }
        }
      });
    } else {
      cobrancasAux = this.cobrancasPix;
    }

    this.cobrancasPix = cobrancasAux;
  }

  filterByStatus(init) {
    this.cobrancasPix = init ? this.cobrancasPix : this.cobrancasPixBkp;
    const cobrancasAux = this.tagglejs.tag.values.length === 0 ? this.cobrancasPix : [];

    let isStatus = false;

    this.tagglejs.tag.values.forEach((tag) => {
      this.status.forEach((status) => {
        if (status.name === tag) {
          isStatus = true;
        }
      });

      this.cobrancasPix.forEach((cobrancaPix) => {
        if (isStatus && tag === 'Pago' && cobrancaPix.DataPagamento) {
          cobrancasAux.push(cobrancaPix);
        } else if (isStatus && tag === 'Pendente' && !cobrancaPix.DataPagamento) {
          cobrancasAux.push(cobrancaPix);
        }
      });
    });

    if (isStatus) {
      this.cobrancasPix = cobrancasAux;
    }
  }

  clickOutListener() {
    const self = this;
    document.addEventListener('click', function(e: any) {
      if (e.target.closest('.box-filter')) { return; }

      if (!self.boxHidden && !e.target.closest('.filter-icon')) {
        self.toggleBox();
      }
    });
  }

  rowClickListener() {
    const self = this;
    $('#master-detail-table tbody').on('click', 'tr', function(e) {
      if (e.target.className !== 'styled-checkbox' && e.target.nodeName !== 'svg' && e.target.localName !== 'polyline') {
        const data = self.table.row(this).data();
        
        if (data && data.ClientId && data.AppSource) {
          let clientProfileUrl = '';
          
          if (data.AppSource.toLowerCase() === 'facilfit') {
            clientProfileUrl = `https://app.facilfit.com.br/#/clientes/perfil-cliente/${data.ClientId}`;
          } else {
            clientProfileUrl = `https://app.actuar.com/#/clientes/perfil-cliente/${data.ClientId}`;
          }
          
          window.open(clientProfileUrl, '_blank');
        }
      }
    });
  }

  formatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  }

    getDocumentType(document: string): string {
    if (!document) return '';
         
    const numbers = document.replace(/\D/g, '');
    
    if (numbers.length === 11) {
      return 'CPF';
    } else if (numbers.length === 14) {
      return 'CNPJ';
    } else {
      return 'DOC';
    }
  }

  formatDocument(document: string): string {
    if (!document) return '';
    
    const numbers = document.replace(/\D/g, '');
    
    if (numbers.length === 11) {
      return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (numbers.length === 14) {
      return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else {
      return document;
    }
  }

  emitirRelatorio() {
    if (!this.cobrancasPix || this.cobrancasPix.length === 0) {
      alert('Não há transações PIX para exportar.');
      return;
    }

    const excelData = this.cobrancasPix.map(cobrancaPix => {
      const dataHora = cobrancaPix.DataPagamento 
        ? moment(cobrancaPix.DataPagamento).format('DD/MM/YYYY HH:mm')
        : 'Pendente';

      const tipoDocCliente = this.getDocumentType(cobrancaPix.CpfCnpj);
      const docFormatadoCliente = this.formatDocument(cobrancaPix.CpfCnpj);
      
      const tipoDocPagador = this.getDocumentType(cobrancaPix.CpfCnpjPagador);
      const docFormatadoPagador = this.formatDocument(cobrancaPix.CpfCnpjPagador);

      return {
        'Cliente': cobrancaPix.Nome,
        'Documento Cliente': cobrancaPix.CpfCnpj ? `${tipoDocCliente}: ${docFormatadoCliente}` : '',
        'Pagador': cobrancaPix.NomePagador,
        'Documento Pagador': cobrancaPix.CpfCnpjPagador ? `${tipoDocPagador}: ${docFormatadoPagador}` : '',
        'Data/Hora': dataHora,
        'Venda': cobrancaPix.Descricao,
        'Chave': cobrancaPix.ChavePix,
        'Valor': (cobrancaPix as any).ValorNumero ?? cobrancaPix.Valor
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    if (worksheet && worksheet['!ref']) {
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      let valorCol: number = null;
      for (let c = range.s.c; c <= range.e.c; c++) {
        const headerAddr = XLSX.utils.encode_cell({ r: range.s.r, c });
        const headerCell = worksheet[headerAddr];
        if (headerCell && headerCell.v === 'Valor') {
          valorCol = c;
          break;
        }
      }
      if (valorCol !== null) {
        for (let r = range.s.r + 1; r <= range.e.r; r++) {
          const addr = XLSX.utils.encode_cell({ r, c: valorCol });
          const cell = worksheet[addr];
          if (cell) {
            cell.t = 'n';
            cell.z = '"R$" #,##0.00';
          }
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Transações PIX');

    const dataAtual = moment().format('DD-MM-YYYY_HH-mm-ss');
    const nomeArquivo = `relatorio_transacoes_pix_${dataAtual}.xlsx`;

    XLSX.writeFile(workbook, nomeArquivo);
  }
}
